import React from "react";
import {IndexRedirect, Route} from "react-router";

import ImageTab from "./index";

import Search from './pages/Search';
import Comparison from './pages/Comparison';
import Upload from "./pages/Upload";
import Dashboard from "./pages/Dashboard";

const routes = () => (
    <Route path='images' component={ImageTab} name={'view image'}>
        <IndexRedirect to='search'/>

        <Route path='search' component={Search}/>
        <Route path='dashboard' component={Dashboard}/>
        <Route path='comparison' component={Comparison}/>
        <Route path='upload' component={Upload}/>
    </Route>
);

export default routes;


// WEBPACK FOOTER //
// ./src/components/Station/Image/routes.js